export default "__VITE_ASSET__f01de082__"